import newsletterConfig from '../../../newsletter-config.json'
import { NewsletterSectionRow, TableWrapper } from "./helpersComponents"
import NewsletterContentImage from "./NewsletterContentImage"

const NewsletterSectionLogo = ({
    cinemaData,
    width = newsletterConfig.cinemaLogoWidth,
    paddingTop = "0",
    paddingRight = "0",
    paddingBottom = "32px",
    paddingLeft = "0"
}) => (
    <NewsletterSectionRow>
        <TableWrapper>
            <tr>
                <NewsletterContentImage
                    url={cinemaData.logoUrl}
                    alt={cinemaData.logoAlt}
                    width={width}
                    align="center"
                    tdStyles={{
                        paddingTop: paddingTop,
                        paddingRight: paddingRight,
                        paddingBottom: paddingBottom,
                        paddingLeft: paddingLeft
                    }}
                />
            </tr>
        </TableWrapper>
    </NewsletterSectionRow>
)

export default NewsletterSectionLogo

